import { clsx } from 'clsx';
import { FC } from 'react';
import { useFilters } from 'organisms/Filters/hooks';
import { Facets, IFilter } from 'commerce/factFinder/types';
import { FilterItem } from '../FilterItem';
import styles from './styles.module.css';

const ColorButton: FC<{ onClick: () => void; isActive: boolean }> = ({
  onClick,
  isActive,
}) => {
  return (
    <FilterItem onClick={onClick} isActive={isActive} className={styles.colors}>
      <div className={styles.colorButton}>
        <div className={clsx(styles.colorBit, styles.colorBit1)} />
        <div className={clsx(styles.colorBit, styles.colorBit2)} />
        <div className={clsx(styles.colorBit, styles.colorBit3)} />
        <div className={clsx(styles.colorBit, styles.colorBit4)} />
      </div>
    </FilterItem>
  );
};

export const ColorButtonContainer = () => {
  const { facets, toggleChips, chipsState } = useFilters();

  const facet = facets.find(
    (facet) => facet.associatedFieldName === Facets.COLORS,
  );

  if (!facet?.elements) {
    return null;
  }

  const chips: IFilter[] = facet.elements.map((el) => {
    return {
      type: Facets.COLORS,
      value: el.text.split('|'),
      displayValue: el.text,
    };
  });

  return (
    <ColorButton
      isActive={chipsState?.filterKey === Facets.COLORS}
      onClick={() => toggleChips('colors', chips, 'top')}
    />
  );
};
